<template>
  <v-container fluid id="top" class="pa-0">
    <v-app-bar :class="{ 'scrolled': isScrolled }"
      :elevation="0" 
      class="px-sm-4">
      <div v-if="!isMobileDevice">
        <v-btn
          text
          :ripple="false"
          v-for="item in items"
          :key="item.title"
          :href="item.value"
          v-smooth-scroll
        >
          {{ item.title }}
        </v-btn>
      </div>
      <v-app-bar-nav-icon
        v-if="isMobileDevice"
        @click="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <v-spacer class="d-sm-none"></v-spacer>
      <v-spacer></v-spacer>
    
      <div v-if="!isMobileDevice">
        <v-row class="justify-center">
        <v-col cols="auto" v-for="link in links" :key="link.url">
          <a :href="link.url" target="_blank">
            <v-img
              width="20"
              :src="link.icon"
              :max-width="link.width"
              style="filter: brightness(10)"
            ></v-img>
          </a>
        </v-col>
      </v-row>
      </div>
      <v-divider v-if="!isMobileDevice" vertical thickness="1" opacity="0.3" class="ml-5 mr-2" style="height:20px; margin-top:22px;"></v-divider>
      <v-menu offset-y>
        <template v-slot:activator="{ props }">
          <v-btn icon v-bind="props">
            <v-icon>mdi-earth</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(language, index) in filteredLanguages"
            :key="index"
            @click="changeLanguage(language.code)"
          >
            <v-list-item-title>{{ language.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

    </v-app-bar>
    <v-navigation-drawer 
    class="navigation-drawer" 
    v-model="drawer" 
    v-if="isMobileDevice">
      <v-list>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          :href="item.value"
          class="text-left"
          v-smooth-scroll
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    <!-- SNSリンク -->
    <div class="mt-10">
      <v-row class="justify-center">
        <v-col cols="auto" v-for="link in links" :key="link.url">
          <a :href="link.url" target="_blank">
            <v-img
              width="20"
              :src="link.icon"
              :max-width="link.width"
              style="filter: brightness(10)"
            ></v-img>
          </a>
        </v-col>
      </v-row>
      </div>
      <!-- SNSタグ   タグの内容はページ下部で設定 -->
    <v-container fluid class="text-left px-0">
      <SocialMediaTags :tags="hashtags" />
    </v-container>
    </v-navigation-drawer>

  </v-container>
</template>

<script setup>
import { inject, ref, reactive, computed, onMounted, onUnmounted, watch } from "vue";
import { useIsMobile } from "@/composables/isMobile";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { getBasePath } from '@/utils/basePath';
import SocialMediaTags from '@/components/SnsTag.vue';

// ハッシュタグ設定ファイルから読み込み
import hashtags from '@/config/hashtags';

const { t, locale } = useI18n();

//  現在の言語コードを定義
const currentLang = computed(() => locale.value);

//  ベースパスを定義
const basePath = computed(() => getBasePath());

// SNSを定義
const links = [
  {
    icon: `${basePath.value}Images/sns/icon_x.svg`,
    url: "https://twitter.com/naked_staff",
    width: "40",
  },
  {
    icon: `${basePath.value}Images/sns/icon_instagram.svg`,
    url: "https://www.instagram.com/naked_inc/",
    width: "40",
  },
  {
    icon: `${basePath.value}Images/sns/icon_youtube.svg`,
    url: "https://www.youtube.com/c/NAKEDINC",
    width: "40",
  },
  {
    icon: `${basePath.value}Images/sns/icon_tiktok.svg`,
    url: "https://www.tiktok.com/@nakedinc",
    width: "16",
  },
];

const { isMobileDevice } = useIsMobile();
const route = useRoute();
const router = useRouter();
const drawer = ref(false);

const state = reactive({
  isMenuOpen: false,
  languages: [
    { name: "日本語", code: "ja" },
    { name: "English", code: "en" },
  ],
  drawer: false,
});

// 隠す言語の指定
const filteredLanguages = computed(() => {
  const hiddenLanguages = ["ko"];
  return state.languages.filter(lang => !hiddenLanguages.includes(lang.code) && lang.code !== locale.value);
});


const items = computed(() => [
  { title: t('menu.top'), value: '#top' },
  { title: t('menu.contents'), value: '#contents' },
  //{ title: t('menu.map'), value: '#map' },
  { title: t('menu.tickets'), value: '#tickets' },
  { title: t('menu.access'), value: '#access' },
]);



function toggleMenu() {
  state.isMenuOpen = !state.isMenuOpen;
}

function changeLanguage(lang) {
  console.log("Changing language to:", lang);
  locale.value = lang;

  // 現在のパスから言語部分を抽出して置き換え
  const currentPath = route.path;
  const newPath = currentPath.replace(/^\/[^\/]+/, `/${lang}`);
  
  console.log("Current path:", currentPath);
  console.log("New path:", newPath);
  
  router.push(newPath);
}


// スクロールしてヒーローイメージを過ぎた時の処理
const isScrolled = ref(false);

const handleScroll = () => {
  const heroVideoContainer = document.querySelector('.hero-video-container');
  if (!heroVideoContainer) {
    // 要素が見つからない場合は、スクロール状態をリセット
    isScrolled.value = false;
    return;
  }

  const rect = heroVideoContainer.getBoundingClientRect();
  isScrolled.value = rect.bottom <= 0;
};

onMounted(() => {
  // 要素が見つかるまで繰り返し試行
  const checkForElement = () => {
    const heroVideoContainer = document.querySelector('.hero-video-container');
    if (heroVideoContainer) {
      const rect = heroVideoContainer.getBoundingClientRect();
      isScrolled.value = rect.bottom <= 0;
      window.addEventListener('scroll', handleScroll);
    } else {
      // 要素が見つからない場合は、少し待ってから再試行
      setTimeout(checkForElement, 500);
    }
  };
  
  // 初回チェックを開始
  setTimeout(checkForElement, 1000);
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

watch(
  () => state.group,
  () => {
    state.drawer = false;
  }
);
</script>




<style lang="scss" scoped>
#top {
  max-width: 100%;
  overflow-x: hidden;
}

.v-app-bar {
  width: 100vw;
  box-sizing: border-box;
}

:deep(.header-logo img.v-img__img) {
  object-position: center center;
  @media screen and (min-width:600px) {
    object-position: left center!important;;
  }
}

.v-app-bar {
  width: 100vw;
  box-sizing: border-box;
  background: rgba(0, 0, 0, 0)!important;
  transition: background-color 0.3s ease;
  }

.v-app-bar.scrolled {
  background: rgba(var(--v-theme-background), .3)!important; /* 好みの背景色に変更 */
}

.navigation-drawer {
  background-color: rgba(var(--v-theme-primary), 1)!important;
  top: 0!important;
  z-index: 1144!important;
  height: 100vh!important;
}

.v-navigation-drawer__scrim{
  background: black;
  opacity: .7;
}

</style>
